import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useProviderDelete } from './useProviderDelete.ts';

export const useProviderDeleteModal = () => {
  const { t } = useTranslation();
  const { open, setLoading, close } = useConfirmationDialog();
  const { deleteProvider } = useProviderDelete();

  return useCallback(
    ({ id, name }) =>
      open({
        confirmationButtonColor: 'error',
        confirmationLabel: t('Delete'),
        content: (
          <DialogContent dividers>
            <Typography>
              {t('You’re about to delete the following provider from')}{' '}
              <Typography component="strong">OpenX Select</Typography>:
            </Typography>
            <Typography variant="body1Bold" sx={{ mb: 3 }}>
              {name}
            </Typography>
            <Typography>{t('Do you want to proceed?')}</Typography>
          </DialogContent>
        ),
        customContent: true,
        onConfirmed: async () => {
          setLoading(true);
          await deleteProvider(id, name);
          setLoading(false);
          close();
        },
        title: t('Delete Provider'),
      }),
    [close, deleteProvider, open, setLoading, t]
  );
};
